#import "../fragments/peep-business-card-info-fragment.graphql"

mutation AddPeepOmnifield($input: OmnifieldAddInput!) {
    entityOmnifieldAdd(input: $input) {
        entity {
            ... on Peep {
                ...PeepBusinessCardInfoFragment
            }
        }
    }
}
